import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonuses = [{
  title: 'Guía Express de perfiles',
  desc: 'Referencia rápida para tener siempre a mano en el taller.'
}, {
  title: 'Tabla profesional de medidas',
  desc: 'Cálculos exactos y tolerancias para cortes perfectos.'
}, {
  title: 'Checklist profesional',
  desc: 'Paso a paso para no olvidar ningún detalle en la instalación.'
}, {
  title: 'Los 25 errores más costosos',
  desc: 'Aprende de los errores de otros y ahorra miles en materiales.'
}, {
  title: '15 proyectos reales',
  desc: 'Planos y despieces de proyectos listos para construir.'
}];
export function Bonus() {
  return <section id="bonus" className="py-24 relative overflow-hidden" data-id="element-26">
      <div className="absolute inset-0 bg-[#2F80ED]/5" data-id="element-27" />
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#2F80ED]/30 to-transparent" data-id="element-28" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#2F80ED]/30 to-transparent" data-id="element-29" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-30">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-31">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-[#2F80ED]/10 text-[#2F80ED] mb-6 blue-glow" data-id="element-32">
            <Gift className="w-8 h-8" data-id="element-33" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold font-heading mb-6" data-id="element-34">
            BONUS EXCLUSIVOS
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-35">
            Herramientas prácticas que complementan tu aprendizaje y aceleran tu
            trabajo diario.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-36">
          {bonuses.map((bonus, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className={`glass-panel rounded-2xl p-6 relative overflow-hidden group hover:border-[#2F80ED]/50 transition-colors ${idx === 4 ? 'md:col-span-2 lg:col-span-1 lg:col-start-2' : ''}`} data-id="element-37">
              <div className="absolute -right-10 -top-10 w-32 h-32 bg-[#2F80ED]/10 rounded-full blur-2xl group-hover:bg-[#2F80ED]/20 transition-colors" data-id="element-38" />

              <div className="w-10 h-10 rounded-lg metallic-gradient flex items-center justify-center mb-4 shadow-lg" data-id="element-39">
                <Gift className="w-5 h-5 text-[#0D1117]" data-id="element-40" />
              </div>

              <h3 className="text-xl font-bold font-heading mb-2 text-white/90" data-id="element-41">
                {bonus.title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-42">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}